module.exports = __webpack_public_path__ + "static/media/IMG_0404.dc6fa5ab.JPG";